function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

var playMarket = {
  "id": "playMarket",
  "symbol": "<symbol id=\"playMarket\" viewBox=\"0 0 30 32\" ><path d=\"M19.331 14.644L5.537 0.813L23.087 10.888L19.331 14.644ZM1.938 0C1.125 0.425 0.582001 1.2 0.582001 2.206V29.787C0.582001 30.793 1.126 31.568 1.938 31.993L17.976 15.993L1.938 0ZM28.512 14.1L24.831 11.969L20.725 16L24.831 20.031L28.587 17.9C29.712 17.007 29.712 14.994 28.512 14.1ZM5.538 31.188L23.088 21.113L19.332 17.357L5.538 31.188Z\" fill=\"#6B7F99\"/></symbol>"
};

export { playMarket };
